<div class="modal modal-content">
  <header class="modal__header" [ngClass]="{'border': hasHeader()}">
    <div class="modal__header-details">
      <ng-content select="modal-header" *ngIf="hasHeader()"></ng-content>
    </div>
    <div class="modal__header-close">

      <ng-container *ngIf="close.observers.length > 0">
        <lds-icon-button
          icon="close"
          appearance="default"
          [isRounded]="true"
          (onClick)="onClose()">
        </lds-icon-button>
      </ng-container>

    </div>
  </header>
  <section class="modal__content">
    <ng-content select="modal-content"></ng-content>
  </section>
  <footer class="modal__footer" *ngIf="hasFooter()">
    <ng-content select="modal-footer"></ng-content>
  </footer>
</div>
